import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=ffab6a3a&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "./comment.vue?vue&type=style&index=0&id=ffab6a3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffab6a3a",
  null
  
)

export default component.exports